// import React, { useCallback, useMemo, useEffect } from 'react';
// import { View, FlatList, RefreshControl, StyleSheet } from 'react-native';
// import { CalendarProvider, ExpandableCalendar, LocaleConfig } from 'react-native-calendars';
// import { endOfDay, format, startOfDay } from 'date-fns';
// import { Text } from '_/components';
// import themes from '_/constants/themes';
// import { fontFamily } from '_/config/theme';
// import { eventsApi } from '_/services/api';
// import { useQuery } from '@tanstack/react-query';
// import { useTranslation } from 'react-i18next';

// interface TimelineProps {
//   companyId: string;
//   selectedDate: string;
//   setSelectedDate: (date: string) => void;
// }

// export const TimelineEvents = ({ companyId, selectedDate, setSelectedDate }: TimelineProps) => {
//   const {
//     data: events = [],
//     isLoading,
//     refetch,
//   } = useQuery({
//     queryKey: ['events', companyId, selectedDate],
//     staleTime: 1000 * 60 * 2,
//     queryFn: async () => {
//       const [year, month, day] = selectedDate.split('-').map(Number);
//       const dateObj = new Date(year, month - 1, day, 12, 0, 0);

//       const start = startOfDay(dateObj);
//       const end = endOfDay(dateObj);

//       const response = await eventsApi.getEvents(companyId, {
//         'createdAt[$gte]': start.toISOString(),
//         'createdAt[$lte]': end.toISOString(),
//         '$sort[createdAt]': -1,
//       });

//       return response?.data || [];
//     },
//     enabled: !!companyId && !!selectedDate,
//   });

//   const onDateChanged = useCallback(
//     (date: string) => {
//       if (date !== selectedDate) {
//         setSelectedDate(date);
//       }
//     },
//     [selectedDate, setSelectedDate]
//   );

//   const marked = useMemo(
//     () => ({
//       [selectedDate]: {
//         selected: true,
//         selectedColor: themes.colors.success,
//         selectedTextColor: '#ffffff',
//       },
//     }),
//     [selectedDate]
//   );

//   return (
//     <CalendarProvider date={selectedDate} onDateChanged={onDateChanged} showTodayButton={false}>
//       <View style={styles.container}>
//         <ExpandableCalendar
//           initialPosition={ExpandableCalendar.positions.CLOSED}
//           markedDates={marked}
//           disablePan={false}
//           hideKnob={false}
//           firstDay={1}
//           theme={{
//             calendarBackground: '#ffffff',
//             selectedDayBackgroundColor: themes.colors.success,
//             textDayFontFamily: fontFamily.regular,
//             textMonthFontFamily: fontFamily.bold,
//           }}
//         />

//         <FlatList
//           data={events}
//           keyExtractor={(item, index) => item?.id?.toString() || `key-${index}`}
//           ListHeaderComponent={
//             <View style={styles.legendContainer}>
//               <LegendItem color={themes.colors.success} label="Presença" />
//               <LegendItem color={themes.colors.warning} label="Atraso" />
//               <LegendItem color={themes.colors.danger} label="Falta" />
//               <LegendItem color={themes.colors.primary} label="Saída" />
//             </View>
//           }
//           renderItem={({ item, index: i }) => {
//             const { color, label } = getEventStyle(item.eventType);
//             const timeFormatted = format(new Date(item.createdAt), 'HH:mm');
//             return (
//               <View style={styles.timelineRow}>
//                 <View style={styles.timeColumn}>
//                   <Text style={styles.timeText}>{timeFormatted}</Text>
//                 </View>
//                 <View style={styles.indicatorColumn}>
//                   <View style={[styles.dot, { backgroundColor: color }]} />
//                   {i !== events.length - 1 && <View style={styles.line} />}
//                 </View>
//                 <View style={styles.contentColumn}>
//                   <View style={[styles.tag, { backgroundColor: color }]}>
//                     <Text style={styles.tagText}>{label}</Text>
//                   </View>
//                   <View style={styles.eventCard}>
//                     <Text style={styles.hostName}>{item['host.name'] || 'Estudante'}</Text>
//                     <Text style={styles.eventInfo}>Registro realizado às {timeFormatted}</Text>
//                   </View>
//                 </View>
//               </View>
//             );
//           }}
//           ListEmptyComponent={
//             isLoading ? null : <Text style={styles.emptyText}>Nenhum registro encontrado</Text>
//           }
//           refreshControl={<RefreshControl refreshing={isLoading} onRefresh={refetch} />}
//           contentContainerStyle={styles.listPadding}
//         />
//       </View>
//     </CalendarProvider>
//   );
// };

// const getEventStyle = (type: string) => {
//   switch (type) {
//     case 'ENTRY':
//     case 'ACCESS_EFFECTED':
//       return { color: themes.colors.success, label: 'PRESENÇA' };
//     case 'ABSENT':
//       return { color: themes.colors.danger, label: 'FALTA' };
//     case 'ENTRY_LATE':
//       return { color: themes.colors.warning, label: 'ATRASO' };
//     case 'EXIT_EARLY':
//     case 'EXIT':
//       return { color: themes.colors.primary, label: 'SAÍDA' };
//     default:
//       return { color: themes.colors.graySecondary, label: 'OUTRO' };
//   }
// };

// const LegendItem = ({ color, label }: any) => (
//   <View style={styles.legendItem}>
//     <View style={[styles.legendDot, { backgroundColor: color }]} />
//     <Text style={styles.legendText}>{label}</Text>
//   </View>
// );

// const styles = StyleSheet.create({
//   container: { flex: 1, backgroundColor: '#F8F9FA' },
//   calendarCard: {
//     backgroundColor: '#FFF',
//     borderRadius: 25,
//     margin: 10,
//     elevation: 4,
//     overflow: 'hidden',
//   },
//   calendar: { paddingLeft: 20, paddingRight: 20 },
//   legendContainer: {
//     flexDirection: 'row',
//     justifyContent: 'center',
//     paddingVertical: 12,
//     borderTopWidth: 1,
//     borderTopColor: '#F0F2F5',
//   },
//   legendItem: { flexDirection: 'row', alignItems: 'center', marginHorizontal: 8 },
//   legendDot: { width: 8, height: 8, borderRadius: 4, marginRight: 6 },
//   legendText: { fontSize: 11, color: '#666', fontFamily: fontFamily.semibold },
//   timelineRow: { flexDirection: 'row', paddingHorizontal: 20 },
//   timeColumn: { width: 45, alignItems: 'flex-end', paddingTop: 4 },
//   timeText: { fontSize: 13, fontFamily: fontFamily.bold, color: '#444' },
//   indicatorColumn: { width: 30, alignItems: 'center' },
//   dot: {
//     width: 12,
//     height: 12,
//     borderRadius: 6,
//     zIndex: 2,
//     marginTop: 6,
//     borderWidth: 2,
//     borderColor: '#FFF',
//   },
//   line: { width: 2, flex: 1, backgroundColor: '#E0E0E0', marginTop: -4 },
//   contentColumn: { flex: 1, paddingBottom: 24 },
//   tag: {
//     alignSelf: 'flex-start',
//     paddingHorizontal: 10,
//     paddingVertical: 2,
//     borderRadius: 6,
//     marginBottom: 6,
//   },
//   tagText: { color: '#FFF', fontSize: 10, fontFamily: fontFamily.bold },
//   eventCard: {
//     backgroundColor: '#FFF',
//     padding: 12,
//     borderRadius: 14,
//     elevation: 1,
//     shadowOpacity: 0.04,
//   },
//   hostName: { fontSize: 15, fontFamily: fontFamily.bold, color: '#333' },
//   eventInfo: { fontSize: 12, color: '#888', marginTop: 2 },
//   listPadding: { paddingBottom: 40, paddingTop: 10 },
//   emptyText: { textAlign: 'center', marginTop: 40, color: '#999' },
// });

import React, { useMemo, useEffect, useState } from 'react';
import { View, FlatList, RefreshControl, StyleSheet } from 'react-native';
import { Calendar, LocaleConfig } from 'react-native-calendars';
import { format, startOfDay, endOfDay } from 'date-fns';
import { Text } from '_/components';
import themes from '_/constants/themes';
import { fontFamily } from '_/config/theme';
import { cfgHwEventsApi, customCfgHwEventsApi, eventsApi } from '_/services/api';

import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { getCalendarLocale } from '_/helpers/Calendarlocales';

const CACHE_24H = 1000 * 60 * 60 * 24;
const DEFAULT_COLOR = themes.colors.graySecondary;

interface TimelineProps {
  companyId: string;
  selectedDate: string;
  setSelectedDate: (date: string) => void;
  timelineEnabled: boolean;
}

const langToColumns: Record<string, { str: string; display: string }> = {
  en: { str: 'strLanguage_en', display: 'DisplayText_en' },
  'pt-BR': { str: 'strLanguage_pt_BR', display: 'DisplayText_pt_BR' },
  es: { str: 'strLanguage_es', display: 'DisplayText_es' },
  fr: { str: 'strLanguage_fr', display: 'DisplayText_fr' },
  de: { str: 'strLanguage_de', display: 'DisplayText_de' },
  'zh-Hans': { str: 'strLanguage_zh_Hans', display: 'DisplayText_zh_Hans' },
};

const DEFAULT_LANG = 'pt-BR';

interface CfgEntry {
  str: string;
  label: string;
  color: string;
  display: boolean;
}

const buildCfgMap = (rows: any[], lang: string): Record<number, CfgEntry> => {
  const cols = langToColumns[lang] ?? langToColumns[DEFAULT_LANG];
  const map: Record<number, CfgEntry> = {};

  for (const row of rows) {
    if (row.EventHWID == null) continue;
    const str = row[cols.str] ?? String(row.EventHWID);
    const label = row[cols.display] ?? str;
    map[row.EventHWID] = {
      str,
      label,
      color: row.color ?? DEFAULT_COLOR,
      display: row.DisplayEvent == null ? true : Boolean(row.DisplayEvent),
    };
  }

  return map;
};

export const TimelineEvents = ({
  companyId,
  selectedDate,
  setSelectedDate,
  timelineEnabled,
}: TimelineProps) => {
  const { i18n } = useTranslation();
  const [calendarKey, setCalendarKey] = useState(0);

  useEffect(() => {
    const locale = getCalendarLocale(i18n.language);
    LocaleConfig.defaultLocale = locale;
    setCalendarKey((prev) => prev + 1);
  }, [i18n.language]);

  const { data: globalCfg = [] } = useQuery({
    queryKey: ['cfg-hw-events'],
    queryFn: () => cfgHwEventsApi.getCfgHwEvents(),
    staleTime: CACHE_24H,
    gcTime: CACHE_24H,
  });

  const { data: customCfg = [] } = useQuery({
    queryKey: ['custom-cfg-hw-events', companyId],
    queryFn: () => customCfgHwEventsApi.getCustomCfgHwEvents(companyId),
    staleTime: CACHE_24H,
    gcTime: CACHE_24H,
    enabled: !!companyId,
  });

  const cfgMap = useMemo(() => {
    const lang = i18n.language;
    const base = buildCfgMap(globalCfg?.data ?? globalCfg, lang);
    const custom = buildCfgMap(customCfg?.data ?? customCfg, lang);
    return { ...base, ...custom };
  }, [globalCfg, customCfg, i18n.language]);

  const legendItems = useMemo(() => {
    const seen = new Map<string, { color: string; label: string }>();

    for (const entry of Object.values(cfgMap)) {
      if (!entry.display) continue;
      if (!seen.has(entry.color)) {
        seen.set(entry.color, { color: entry.color, label: entry.label });
      }
    }

    return Array.from(seen.values());
  }, [cfgMap]);

  const {
    data: events = [],
    isLoading,
    refetch,
  } = useQuery({
    queryKey: ['events', companyId, selectedDate, timelineEnabled],
    staleTime: 1000 * 60 * 2,
    queryFn: async () => {
      const [year, month, day] = selectedDate.split('-').map(Number);
      const dateObj = new Date(year, month - 1, day, 12, 0, 0);

      const response = await eventsApi.getEvents(companyId, {
        'createdAt[$gte]': startOfDay(dateObj).toISOString(),
        'createdAt[$lte]': endOfDay(dateObj).toISOString(),
        '$sort[createdAt]': -1,
      });

      return response?.data || [];
    },
    enabled: !!companyId && !!selectedDate && timelineEnabled,
  });

  const marked = useMemo(
    () => ({
      [selectedDate]: {
        selected: true,
        disableTouchEvents: true,
        selectedColor: themes.colors.success,
        selectedTextColor: '#ffffff',
      },
    }),
    [selectedDate]
  );

  const renderHeader = () => (
    <View style={styles.calendarCard}>
      <Calendar
        key={calendarKey}
        current={selectedDate}
        onDayPress={(day) => setSelectedDate(day.dateString)}
        markedDates={marked}
        enableSwipeMonths={true}
        theme={{
          calendarBackground: '#ffffff',
          dayTextColor: '#2d4150',
          monthTextColor: '#2d4150',
          selectedDayBackgroundColor: themes.colors.success,
          selectedDayTextColor: '#ffffff',
          todayTextColor: themes.colors.primary,
          textDayFontFamily: fontFamily.regular,
          textMonthFontFamily: fontFamily.bold,
          textDayHeaderFontFamily: fontFamily.semibold,
          arrowColor: themes.colors.primary,
        }}
      />
      <View style={styles.legendContainer}>
        {legendItems.map((item) => (
          <LegendItem key={item.color} color={item.color} label={item.label} />
        ))}
      </View>
    </View>
  );

  return (
    <FlatList
      data={events}
      keyExtractor={(item, index) => item?.id?.toString() || `key-${index}`}
      ListHeaderComponent={renderHeader}
      renderItem={({ item, index: i }) => {
        if (!item) return null;

        const cfg = cfgMap[item.eventHWID];
        const color = cfg?.color ?? DEFAULT_COLOR;
        const strText = cfg?.str ?? String(item.eventHWID);
        const displayText = cfg?.label ?? strText;
        const timeFormatted = format(new Date(item.createdAt), 'HH:mm');

        return (
          <View style={styles.timelineRow}>
            <View style={styles.timeColumn}>
              <Text style={styles.timeText}>{timeFormatted}</Text>
            </View>
            <View style={styles.indicatorColumn}>
              <View style={[styles.dot, { backgroundColor: color }]} />
              {i !== events.length - 1 && <View style={styles.line} />}
            </View>
            <View style={styles.contentColumn}>
              <View style={[styles.tag, { backgroundColor: color }]}>
                <Text style={styles.tagText}>{displayText}</Text>
              </View>
              <View style={styles.eventCard}>
                <Text style={styles.hostName}>{item.hostName}</Text>
                <Text style={styles.eventInfo}>
                  {strText} - {timeFormatted}
                </Text>
              </View>
            </View>
          </View>
        );
      }}
      ListEmptyComponent={
        isLoading ? null : <Text style={styles.emptyText}>Nenhum registro encontrado</Text>
      }
      refreshControl={
        <RefreshControl
          refreshing={isLoading}
          onRefresh={refetch}
          colors={[themes.colors.primary]}
        />
      }
      contentContainerStyle={styles.listPadding}
    />
  );
};

const LegendItem = ({ color, label }: { color: string; label: string }) => (
  <View style={styles.legendItem}>
    <View style={[styles.legendDot, { backgroundColor: color }]} />
    <Text style={styles.legendText}>{label}</Text>
  </View>
);

const styles = StyleSheet.create({
  calendarCard: {
    backgroundColor: '#FFF',
    borderRadius: 20,
    margin: 10,
    paddingBottom: 5,
    elevation: 4,
    shadowColor: '#000',
    shadowOpacity: 0.1,
    shadowRadius: 4,
    overflow: 'hidden',
  },
  legendContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    paddingVertical: 12,
    borderTopWidth: 1,
    borderTopColor: '#F0F2F5',
  },
  legendItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginHorizontal: 8,
    marginVertical: 2,
  },
  legendDot: { width: 8, height: 8, borderRadius: 4, marginRight: 6 },
  legendText: { fontSize: 11, color: '#666', fontFamily: fontFamily.semibold },
  timelineRow: { flexDirection: 'row', paddingHorizontal: 20 },
  timeColumn: { width: 45, alignItems: 'flex-end', paddingTop: 4 },
  timeText: { fontSize: 13, fontFamily: fontFamily.bold, color: '#444' },
  indicatorColumn: { width: 30, alignItems: 'center' },
  dot: {
    width: 12,
    height: 12,
    borderRadius: 6,
    zIndex: 2,
    marginTop: 6,
    borderWidth: 2,
    borderColor: '#FFF',
  },
  line: { width: 2, flex: 1, backgroundColor: '#E0E0E0', marginTop: -4 },
  contentColumn: { flex: 1, paddingBottom: 24 },
  tag: {
    alignSelf: 'flex-start',
    paddingHorizontal: 10,
    paddingVertical: 2,
    borderRadius: 6,
    marginBottom: 6,
  },
  tagText: { color: '#FFF', fontSize: 10, fontFamily: fontFamily.bold },
  eventCard: { backgroundColor: '#FFF', padding: 12, borderRadius: 14, elevation: 1 },
  hostName: { fontSize: 15, fontFamily: fontFamily.bold, color: '#333' },
  eventInfo: { fontSize: 12, color: '#888', marginTop: 2 },
  listPadding: { paddingBottom: 40 },
  emptyText: { textAlign: 'center', marginTop: 40, color: '#999' },
});
